import { Injectable } from '@angular/core';

import { Action, Actions, State, StateContext } from '@ngxs/store';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { ReferralsCondition } from '@recruitee/http/types';

import { HttpApiService } from '../../../core/http-api.service';
import { EntityStateHelpers, EntityUpdateStrategy, IEntityState } from '../../../core/state';
import { EntityState } from '../../../core/state/entity-state';
import { LoadReferralsConditions } from './conditions.actions';

type RepositoryType = IEntityState<ReferralsCondition>;

@State<RepositoryType>({
  name: 'conditions',
  defaults: EntityStateHelpers.createDefaultState(),
})
@Injectable()
export class ReferralsPortalConditionsRepo extends EntityState<ReferralsCondition>() {
  constructor(private httpApi: HttpApiService, protected actions$: Actions) {
    super(actions$, EntityUpdateStrategy.update);
  }

  @Action(LoadReferralsConditions)
  public loadReferralsConditions(
    ctx: StateContext<RepositoryType>,
    action: LoadReferralsConditions,
  ): Observable<ReferralsCondition[]> {
    this.markAsLoading(ctx, action);
    return this.httpApi.get('/conditions').pipe(
      tap(res => {
        this.saveMany(ctx, action, res.conditions);
      }),
    );
  }
}
